import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/small-logo.webp'


const _withScopeId = n => (_pushScopeId("data-v-9c1998d0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bar-right" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "bar-menu-content" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" HOME ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" ABOUT ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" CONTACT ")

import { inject, reactive } from 'vue'
import VueScrollTo from 'vue-scrollto'


export default /*#__PURE__*/_defineComponent({
  __name: 'NavBarMobile',
  setup(__props) {

const scrollTo = VueScrollTo.scrollTo

const data = reactive({
  showMenu: false,
  isTablet: inject('isTablet')
})
function animate() {
  // event.target.parentNode.classList.toggle('active')
  document.getElementsByClassName('burger')[0].classList.toggle('active')
  data.showMenu = !data.showMenu
}

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("header", {
    class: _normalizeClass(["bar", {active: !data.showMenu}]),
    id: "navbar"
  }, [
    _createElementVNode("img", {
      class: _normalizeClass(["bar-logo", {tablet: data.isTablet}]),
      src: _imports_0,
      alt: ""
    }, null, 2),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("a", {
        class: _normalizeClass(["burger", {tablet: data.isTablet}]),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (animate())),
        href: "#"
      }, _hoisted_3, 2)
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["bar-menu", {active: data.showMenu}])
    }, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_RouterLink, {
          class: "bar-menu-content-text",
          onClickPassive: _cache[1] || (_cache[1] = 
            () => {
              _unref(scrollTo)('#top', 1200, { offset: -300 });animate()
          }),
          to: `/`
        }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        }),
        _createVNode(_component_RouterLink, {
          class: "bar-menu-content-text",
          onClickPassive: _cache[2] || (_cache[2] = 
            () => {
              _unref(scrollTo)('#about-us', 1800, { offset: -50 });animate()
          }),
          to: `/`
        }, {
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        }),
        _createVNode(_component_RouterLink, {
          class: "bar-menu-content-text",
          onClickPassive: _cache[3] || (_cache[3] = 
            () => {
              _unref(scrollTo)('#contact', 2700, { offset: -500 });animate()
          }),
          to: `/`
        }, {
          default: _withCtx(() => [
            _hoisted_7
          ]),
          _: 1
        })
      ])
    ], 2)
  ], 2))
}
}

})